import * as Neb from "nebulas" ;
import * as NebPay from 'nebpay';

const contractAddress = 'n1pfYgbB6z46wNWcfwb8Phw9k3n3jRo4Kut';

// Contract addresses

// MAINNET
// ALPHA_v0.1 - n22Q5EVfQEFfAV6EDpzj4cakX9yxMPVg2fQ

// TESTNET
// Mostly unusable ...

const nebPay = new NebPay();
const neb = new Neb.Neb();
const api = neb.api;

// Endpoints
// Mainnet: https://mainnet.nebulas.io
// Testnet: https://testnet.nebulas.io
// Local: http://localhost:8685

neb.setRequest(new Neb.HttpRequest("https://mainnet.nebulas.io"));

export { contractAddress, neb, nebPay, api };


// WEBPACK FOOTER //
// ./src/util/nebulas.js